import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant',
        });

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        const wrappers = document.querySelectorAll('.wrapper, .main-content, #root, .scroll-container');
        wrappers.forEach(wrapper => {
            wrapper.scrollTop = 0;
        });

    }, [pathname]);

    return null;
};

export default ScrollToTop;
